import { render, staticRenderFns } from "./FullviewReports.vue?vue&type=template&id=61ebd772&scoped=true"
import script from "./FullviewReports.vue?vue&type=script&lang=ts"
export * from "./FullviewReports.vue?vue&type=script&lang=ts"
import style0 from "./FullviewReports.vue?vue&type=style&index=0&id=61ebd772&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61ebd772",
  null
  
)

export default component.exports